import { getBasicFormatted, PERCENT } from 'NewAngular/utils/number_formatter';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "../../../../../../../../charts/static/charts/ts/features/bar-chart/bar-chart.component";
function SectorExposureComparisonChart_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 32)(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const sector_r1 = ctx.$implicit;
    const idx_r2 = ctx.index;
    i0.ɵɵadvance();
    i0.ɵɵclassMapInterpolate1("chart-legend-item-title bullet-", idx_r2 + 1, "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(sector_r1.name);
} }
// Constants & utils
/**
 *
 * Sector Exposure Comparison Table.
 *
 */
export class SectorExposureComparisonChart {
    constructor() { }
    formatPercentage(value) {
        if (value == null)
            return '--';
        return getBasicFormatted(value, PERCENT, 2);
    }
}
SectorExposureComparisonChart.ɵfac = function SectorExposureComparisonChart_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SectorExposureComparisonChart)(); };
SectorExposureComparisonChart.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SectorExposureComparisonChart, selectors: [["ycn-sector-exposure-comparison"]], inputs: { exposureData: "exposureData", sectorChartData: "sectorChartData" }, standalone: false, decls: 81, vars: 13, consts: [["data-test-id", "overlap-sector-exposure-data", 1, "panel", "panel-data"], [1, "panel-header"], [1, "panel-title"], [1, "panel-content"], [1, "chart-options"], [1, "chart-legend"], ["class", "chart-legend-item", 4, "ngFor", "ngForOf"], [1, "divider-horizontal"], [1, "panel-content", "mb-0"], [1, "row", "wide-gutters"], [1, "col-8", "col-lg-9", "pr-20", "divider-vertical"], [1, "chart-interactive"], [1, "chart-item"], [1, "chart-wrap"], [1, "chart-canvas", 2, "height", "400px"], [3, "chartData"], [1, "col-4", "col-lg-3", "pl-20"], [1, "table"], [1, "text-thin"], [1, "text-thin", "text-right"], [1, "chart-legend-item-title", "bullet-1"], [1, "text-right", 3, "textContent"], [1, "chart-legend-item-title", "bullet-2"], [1, "chart-legend-item-title", "bullet-3"], [1, "chart-legend-item-title", "bullet-4"], [1, "chart-legend-item-title", "bullet-5"], [1, "chart-legend-item-title", "bullet-6"], [1, "chart-legend-item-title", "bullet-7"], [1, "chart-legend-item-title", "bullet-8"], [1, "chart-legend-item-title", "bullet-9"], [1, "chart-legend-item-title", "bullet-10"], [1, "chart-legend-item-title", "bullet-11"], [1, "chart-legend-item"]], template: function SectorExposureComparisonChart_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "h3", 2);
        i0.ɵɵtext(3, "Sector Exposure Comparison");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(4, "div", 3)(5, "div", 4)(6, "div", 5);
        i0.ɵɵtemplate(7, SectorExposureComparisonChart_div_7_Template, 3, 4, "div", 6);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelement(8, "div", 7);
        i0.ɵɵelementStart(9, "div", 8)(10, "div", 9)(11, "div", 10)(12, "div", 11)(13, "div", 12)(14, "div", 13)(15, "div", 14);
        i0.ɵɵelement(16, "ycn-bar-chart", 15);
        i0.ɵɵelementEnd()()()()();
        i0.ɵɵelementStart(17, "div", 16)(18, "table", 17)(19, "thead")(20, "tr")(21, "td", 18);
        i0.ɵɵtext(22, "Sector");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(23, "td", 19);
        i0.ɵɵtext(24, "Weight");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(25, "tbody")(26, "tr")(27, "td")(28, "span", 20);
        i0.ɵɵtext(29, "Comm. Services");
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(30, "td", 21);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(31, "tr")(32, "td")(33, "span", 22);
        i0.ɵɵtext(34, "Cons. Discretionary");
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(35, "td", 21);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(36, "tr")(37, "td")(38, "span", 23);
        i0.ɵɵtext(39, "Cons. Staples");
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(40, "td", 21);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(41, "tr")(42, "td")(43, "span", 24);
        i0.ɵɵtext(44, "Energy");
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(45, "td", 21);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(46, "tr")(47, "td")(48, "span", 25);
        i0.ɵɵtext(49, "Financials");
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(50, "td", 21);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(51, "tr")(52, "td")(53, "span", 26);
        i0.ɵɵtext(54, "Healthcare");
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(55, "td", 21);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(56, "tr")(57, "td")(58, "span", 27);
        i0.ɵɵtext(59, "Industrials");
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(60, "td", 21);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(61, "tr")(62, "td")(63, "span", 28);
        i0.ɵɵtext(64, "Technology");
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(65, "td", 21);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(66, "tr")(67, "td")(68, "span", 29);
        i0.ɵɵtext(69, "Materials");
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(70, "td", 21);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(71, "tr")(72, "td")(73, "span", 30);
        i0.ɵɵtext(74, "Real Estate");
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(75, "td", 21);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(76, "tr")(77, "td")(78, "span", 31);
        i0.ɵɵtext(79, "Utilities");
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(80, "td", 21);
        i0.ɵɵelementEnd()()()()()()();
    } if (rf & 2) {
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("ngForOf", ctx.sectorChartData);
        i0.ɵɵadvance(9);
        i0.ɵɵproperty("chartData", ctx.sectorChartData);
        i0.ɵɵadvance(14);
        i0.ɵɵproperty("textContent", ctx.formatPercentage(ctx.exposureData.communication_services_exposure));
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("textContent", ctx.formatPercentage(ctx.exposureData.consumer_cyclical_exposure));
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("textContent", ctx.formatPercentage(ctx.exposureData.consumer_defensive_exposure));
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("textContent", ctx.formatPercentage(ctx.exposureData.energy_exposure));
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("textContent", ctx.formatPercentage(ctx.exposureData.financial_services_exposure));
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("textContent", ctx.formatPercentage(ctx.exposureData.healthcare_exposure));
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("textContent", ctx.formatPercentage(ctx.exposureData.industrials_exposure));
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("textContent", ctx.formatPercentage(ctx.exposureData.technology_exposure));
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("textContent", ctx.formatPercentage(ctx.exposureData.basic_materials_exposure));
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("textContent", ctx.formatPercentage(ctx.exposureData.real_estate_exposure));
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("textContent", ctx.formatPercentage(ctx.exposureData.utilities_exposure));
    } }, dependencies: [i1.NgForOf, i2.BarChartComponent], encapsulation: 2 });
